import { LinkButton } from '@tv2/lib-offspring/components/link/Link';
import { useServiceMessages } from '@/libraries/serviceMessages';

export function ServiceStatusMessages() {
  const { serviceStatusMessages } = useServiceMessages();
  const messageLinkText = 'Se med her i stedet';

  if (serviceStatusMessages.length === 0) return null;

  return (
    <div className="flex flex-col">
      {serviceStatusMessages.map(m => (
        <div
          key={m.id}
          className="flex max-[576px]:flex-col flex-row justify-between w-full bg-white px-16 py-3 max-[576px]:px-3"
        >
          <div className="text-legacy-body-s text-midnight min-[576px]:self-center">
            {m.description}
          </div>
          {m.link && (
            <div className="max-[576px]:mt-4">
              <LinkButton href={m.link} color="primary-red">
                {messageLinkText}
              </LinkButton>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
